import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Pagination } from './pagination'
@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  pagination!: Pagination;
  @Input() totalPages!: number;
  @Input() currentPage!: number;
  @Output() pageChanged: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }
  ngOnInit() {
    this.pagination = new Pagination();
    this.pagination.pageIndex = 1;
  }
  PageSizeForPagination() {
    return 6;
  }
  ngOnChanges() {
    if (this.pagination) {
      this.pagination.pageIndex = this.currentPage
    }
  }
  PageChanged(pageIndex: number) {
    this.pagination = new Pagination();
    this.pagination.pageIndex = pageIndex;
    this.pageChanged.emit(this.pagination);
  }

  GetNumberOfPages = (currentPage: number) => {
    var pagesToreturn = 0;
    var arrayToreturn = new Array();
    if ((this.totalPages - this.PageSizeForPagination()) > currentPage) {
      pagesToreturn = currentPage + this.PageSizeForPagination();

    }
    else {
      if ((this.totalPages - this.PageSizeForPagination()) < 0) { currentPage = 1; }
      else {
        currentPage = this.totalPages - this.PageSizeForPagination();
      }
      pagesToreturn = this.totalPages;
    }
    if (currentPage == 0) {
      currentPage = 1;
    }
    for (var i = currentPage; i <= pagesToreturn; i++) {
      arrayToreturn.push(i);
    }
    return arrayToreturn;
  }
}
